export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  category: string;
  categorySlug: string;
  status: '连载中' | '已完结';
  description: string;
  coverImage: string;
  rating: number;
  views: number;
  chapters: ComicChapter[];
  tags: string[];
  updatedAt: string;
  createdAt: string;
  isHot: boolean;
  isNew: boolean;
}

export interface Category {
  name: string;
  slug: string;
  description: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { name: '恋爱', slug: 'love', description: '甜蜜浪漫的爱情故事，感受心动瞬间', icon: 'ri-heart-line', count: 128 },
  { name: '奇幻', slug: 'fantasy', description: '穿越异世界，探索无限可能', icon: 'ri-magic-line', count: 95 },
  { name: '热血', slug: 'action', description: '激情燃烧的战斗，热血沸腾的冒险', icon: 'ri-fire-line', count: 87 },
  { name: '搞笑', slug: 'comedy', description: '轻松幽默，笑料不断的欢乐时光', icon: 'ri-emotion-laugh-line', count: 64 },
  { name: '悬疑', slug: 'mystery', description: '扣人心弦的推理，层层揭开的谜团', icon: 'ri-search-eye-line', count: 53 },
  { name: '都市', slug: 'urban', description: '现代都市生活，真实又精彩', icon: 'ri-building-line', count: 76 },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '她的秘密花园',
    author: '金秀雅',
    category: '恋爱',
    categorySlug: 'love',
    status: '连载中',
    description: '普通上班族林小夏意外发现自己拥有一座神秘的秘密花园，每当她走进去，就能遇见不同的奇妙冒险。在这个充满魔法与浪漫的世界里，她遇到了神秘的花园守护者，两人之间展开了一段跨越现实与幻想的唯美爱情故事。随着花园的秘密被逐渐揭开，林小夏也发现了自己身世的惊人真相。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20manga%20illustration%2C%20beautiful%20female%20protagonist%20in%20a%20secret%20garden%20filled%20with%20magical%20flowers%2C%20soft%20warm%20lighting%2C%20watercolor%20texture%2C%20dreamy%20atmosphere%2C%20romantic%20anime%20art%20style%2C%20clean%20composition%2C%20pastel%20color%20palette%2C%20delicate%20linework%2C%20emotional%20expression&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    rating: 9.5,
    views: 1258000,
    chapters: [
      { id: 'ch-1-1', title: '第1话 意外发现', number: 1, updatedAt: '2026-07-28' },
      { id: 'ch-1-2', title: '第2话 花园守护者', number: 2, updatedAt: '2026-07-21' },
      { id: 'ch-1-3', title: '第3话 魔法之门', number: 3, updatedAt: '2026-07-14' },
      { id: 'ch-1-4', title: '第4话 初次心动', number: 4, updatedAt: '2026-07-07' },
      { id: 'ch-1-5', title: '第5话 身世之谜', number: 5, updatedAt: '2026-06-30' },
      { id: 'ch-1-6', title: '第6话 命运交错', number: 6, updatedAt: '2026-06-23' },
      { id: 'ch-1-7', title: '第7话 花园深处', number: 7, updatedAt: '2026-06-16' },
      { id: 'ch-1-8', title: '第8话 两个人的秘密', number: 8, updatedAt: '2026-06-09' },
    ],
    tags: ['恋爱', '奇幻', '日常', '治愈'],
    updatedAt: '2026-07-28',
    createdAt: '2026-05-01',
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-2',
    title: '剑与魔法的时代',
    author: '朴志勋',
    category: '奇幻',
    categorySlug: 'fantasy',
    status: '连载中',
    description: '在剑与魔法并存的中世纪奇幻世界，少年艾伦从一名普通学徒成长为拯救世界的英雄。在这个充满龙、精灵和魔法的世界里，他必须面对黑暗势力的威胁，同时解开上古预言中隐藏的真相。这是一段关于勇气、友情和牺牲的史诗冒险。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20action%20manga%20illustration%2C%20young%20male%20warrior%20holding%20a%20glowing%20sword%20in%20a%20medieval%20fantasy%20world%2C%20epic%20battle%20scene%20background%20with%20dragon%20silhouette%2C%20dramatic%20lighting%2C%20rich%20colors%2C%20detailed%20armor%20design%2C%20dynamic%20composition%2C%20clean%20linework&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    rating: 9.2,
    views: 980000,
    chapters: [
      { id: 'ch-2-1', title: '第1话 命运的开始', number: 1, updatedAt: '2026-07-27' },
      { id: 'ch-2-2', title: '第2话 试炼之路', number: 2, updatedAt: '2026-07-20' },
      { id: 'ch-2-3', title: '第3话 龙之谷', number: 3, updatedAt: '2026-07-13' },
      { id: 'ch-2-4', title: '第4话 黑暗降临', number: 4, updatedAt: '2026-07-06' },
      { id: 'ch-2-5', title: '第5话 光明之剑', number: 5, updatedAt: '2026-06-29' },
    ],
    tags: ['奇幻', '冒险', '战斗', '成长'],
    updatedAt: '2026-07-27',
    createdAt: '2026-04-15',
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-3',
    title: '校园战神',
    author: '李东旭',
    category: '热血',
    categorySlug: 'action',
    status: '连载中',
    description: '转学生韩宇轩来到了一所充满暴力和不公的高中，凭借一身过人的格斗本领，他决心打破学校里的黑暗规则，保护弱小的同学。在一次次激烈的战斗中，他逐渐揭开了这所学校背后隐藏的巨大阴谋。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20action%20school%20fighting%20manga%20illustration%2C%20cool%20male%20student%20in%20school%20uniform%20with%20fists%20clenched%2C%20dynamic%20action%20pose%2C%20school%20building%20background%2C%20intense%20expression%2C%20bold%20linework%2C%20vibrant%20colors%2C%20dramatic%20lighting&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    rating: 9.0,
    views: 1100000,
    chapters: [
      { id: 'ch-3-1', title: '第1话 新来的转学生', number: 1, updatedAt: '2026-07-26' },
      { id: 'ch-3-2', title: '第2话 第一次出手', number: 2, updatedAt: '2026-07-19' },
      { id: 'ch-3-3', title: '第3话 校园霸主', number: 3, updatedAt: '2026-07-12' },
    ],
    tags: ['热血', '校园', '战斗', '友情'],
    updatedAt: '2026-07-26',
    createdAt: '2026-06-01',
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-4',
    title: '便利店奇遇记',
    author: '崔美玲',
    category: '搞笑',
    categorySlug: 'comedy',
    status: '已完结',
    description: '倒霉大学生张伟在一家24小时便利店里打工，每天遇到各种奇葩顾客和令人捧腹大笑的事件。从深夜的醉酒大叔到买奇怪商品的神秘美女，每一话都让人笑到停不下来。这是一部让你忘记烦恼的治愈系搞笑漫画！',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20comedy%20slice%20of%20life%20manga%20illustration%2C%20funny%20male%20college%20student%20working%20at%20a%20convenience%20store%2C%20colorful%20store%20interior%20background%2C%20exaggerated%20funny%20expression%2C%20bright%20cheerful%20colors%2C%20lighthearted%20atmosphere%2C%20clean%20cartoon%20style&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    rating: 8.8,
    views: 750000,
    chapters: [
      { id: 'ch-4-1', title: '第1话 上班第一天', number: 1, updatedAt: '2026-07-01' },
      { id: 'ch-4-2', title: '第2话 深夜来客', number: 2, updatedAt: '2026-06-24' },
      { id: 'ch-4-3', title: '第3话 神秘商品', number: 3, updatedAt: '2026-06-17' },
    ],
    tags: ['搞笑', '日常', '治愈', '校园'],
    updatedAt: '2026-07-01',
    createdAt: '2026-03-10',
    isHot: false,
    isNew: false,
  },
  {
    id: 'comic-5',
    title: '迷雾之城',
    author: '尹智恩',
    category: '悬疑',
    categorySlug: 'mystery',
    status: '连载中',
    description: '侦探李贤宇接到一起离奇的失踪案，受害者在一个雾霾笼罩的夜晚神秘消失。随着调查的深入，他发现这起案件与十年前的一起连环杀人案有着千丝万缕的联系。迷雾之中，真相究竟是什么？',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20mystery%20thriller%20manga%20illustration%2C%20detective%20in%20trench%20coat%20standing%20in%20foggy%20city%20street%20at%20night%2C%20mysterious%20atmosphere%2C%20dark%20moody%20lighting%2C%20noir%20aesthetic%2C%20detailed%20background%2C%20suspenseful%20tone%2C%20cool%20color%20palette&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    rating: 9.3,
    views: 680000,
    chapters: [
      { id: 'ch-5-1', title: '第1话 失踪', number: 1, updatedAt: '2026-07-25' },
      { id: 'ch-5-2', title: '第2话 线索', number: 2, updatedAt: '2026-07-18' },
      { id: 'ch-5-3', title: '第3话 旧案', number: 3, updatedAt: '2026-07-11' },
      { id: 'ch-5-4', title: '第4话 追凶', number: 4, updatedAt: '2026-07-04' },
    ],
    tags: ['悬疑', '推理', '犯罪', '心理'],
    updatedAt: '2026-07-25',
    createdAt: '2026-05-20',
    isHot: false,
    isNew: true,
  },
  {
    id: 'comic-6',
    title: '首尔恋爱物语',
    author: '韩素英',
    category: '都市',
    categorySlug: 'urban',
    status: '连载中',
    description: '在首尔繁华的江南区，四位性格迥异的都市女性各自追寻着爱情与梦想。从职场精英到自由职业者，她们在摩天大楼和咖啡馆之间，经历着现代都市生活中的甜蜜与苦涩。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20urban%20romance%20manga%20illustration%2C%20stylish%20modern%20woman%20in%20Seoul%20cityscape%20background%2C%20fashionable%20outfit%2C%20coffee%20shop%20scene%2C%20warm%20city%20lights%2C%20romantic%20atmosphere%2C%20clean%20sophisticated%20art%20style%2C%20soft%20colors&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    rating: 8.7,
    views: 820000,
    chapters: [
      { id: 'ch-6-1', title: '第1话 江南的早晨', number: 1, updatedAt: '2026-07-24' },
      { id: 'ch-6-2', title: '第2话 偶遇', number: 2, updatedAt: '2026-07-17' },
      { id: 'ch-6-3', title: '第3话 心动信号', number: 3, updatedAt: '2026-07-10' },
    ],
    tags: ['都市', '恋爱', '职场', '生活'],
    updatedAt: '2026-07-24',
    createdAt: '2026-06-10',
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-7',
    title: '异世界餐厅',
    author: '金泰亨',
    category: '奇幻',
    categorySlug: 'fantasy',
    status: '连载中',
    description: '落魄厨师陈明在一场意外中穿越到了异世界，在这里他发现自己做的料理能够赋予食客神奇的力量。他开了一家小小的餐厅，用美食治愈着异世界的居民，也收获了真挚的友情和爱情。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20cooking%20manga%20illustration%2C%20cheerful%20chef%20in%20a%20magical%20fantasy%20restaurant%2C%20delicious%20food%20with%20magical%20glow%2C%20cozy%20warm%20interior%2C%20whimsical%20atmosphere%2C%20bright%20warm%20colors%2C%20detailed%20food%20art%2C%20heartwarming%20scene&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    rating: 9.1,
    views: 690000,
    chapters: [
      { id: 'ch-7-1', title: '第1话 意外穿越', number: 1, updatedAt: '2026-07-23' },
      { id: 'ch-7-2', title: '第2话 第一道菜', number: 2, updatedAt: '2026-07-16' },
      { id: 'ch-7-3', title: '第3话 神奇的顾客', number: 3, updatedAt: '2026-07-09' },
    ],
    tags: ['奇幻', '美食', '治愈', '冒险'],
    updatedAt: '2026-07-23',
    createdAt: '2026-05-15',
    isHot: false,
    isNew: true,
  },
  {
    id: 'comic-8',
    title: '拳皇之路',
    author: '郑宇成',
    category: '热血',
    categorySlug: 'action',
    status: '已完结',
    description: '少年刘明从小在街头长大，凭借一双铁拳打出了自己的名号。为了追寻更强的对手，他踏上了成为"拳皇"的漫漫征途。一路上他遇到了志同道合的伙伴，也面对了一个又一个强大的敌人。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fighting%20martial%20arts%20manga%20illustration%2C%20powerful%20male%20fighter%20in%20boxing%20stance%2C%20intense%20determined%20expression%2C%20arena%20background%20with%20dramatic%20spotlight%2C%20dynamic%20energy%2C%20bold%20linework%2C%20vibrant%20red%20and%20black%20color%20scheme&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    rating: 9.4,
    views: 1350000,
    chapters: [
      { id: 'ch-8-1', title: '第1话 街头少年', number: 1, updatedAt: '2026-06-15' },
      { id: 'ch-8-2', title: '第2话 初战告捷', number: 2, updatedAt: '2026-06-08' },
      { id: 'ch-8-3', title: '第3话 劲敌出现', number: 3, updatedAt: '2026-06-01' },
    ],
    tags: ['热血', '格斗', '成长', '竞技'],
    updatedAt: '2026-06-15',
    createdAt: '2026-01-20',
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-9',
    title: '甜蜜契约',
    author: '朴恩惠',
    category: '恋爱',
    categorySlug: 'love',
    status: '连载中',
    description: '为了拯救家族企业，千金小姐苏婉与冷酷总裁陆景琛签订了一份契约婚姻。起初只是各取所需，却在朝夕相处中渐渐产生真情。然而家族的秘密和商业的阴谋，让这段感情面临重重考验。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20drama%20manga%20illustration%2C%20elegant%20couple%20in%20formal%20attire%2C%20luxurious%20mansion%20background%2C%20romantic%20tension%2C%20soft%20elegant%20lighting%2C%20detailed%20fashion%2C%20sophisticated%20art%20style%2C%20warm%20golden%20tones&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    rating: 9.0,
    views: 920000,
    chapters: [
      { id: 'ch-9-1', title: '第1话 契约', number: 1, updatedAt: '2026-07-22' },
      { id: 'ch-9-2', title: '第2话 同居生活', number: 2, updatedAt: '2026-07-15' },
      { id: 'ch-9-3', title: '第3话 真情流露', number: 3, updatedAt: '2026-07-08' },
    ],
    tags: ['恋爱', '契约婚姻', '豪门', '女性向'],
    updatedAt: '2026-07-22',
    createdAt: '2026-05-05',
    isHot: false,
    isNew: true,
  },
  {
    id: 'comic-10',
    title: '办公室的猫',
    author: '李智恩',
    category: '搞笑',
    categorySlug: 'comedy',
    status: '连载中',
    description: '某天，一家普通公司的办公室里突然出现了一只神秘的花猫。这只猫不仅会偷偷喝员工的咖啡，还会在键盘上敲出奇怪的文件。围绕着这只猫，办公室的日常变得越来越离谱和搞笑。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20comedy%20office%20life%20manga%20illustration%2C%20cute%20cat%20sitting%20on%20an%20office%20desk%20with%20keyboard%2C%20funny%20office%20workers%20in%20background%2C%20bright%20colorful%20office%20setting%2C%20whimsical%20funny%20atmosphere%2C%20clean%20cartoon%20style%2C%20lighthearted%20mood&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    rating: 8.6,
    views: 580000,
    chapters: [
      { id: 'ch-10-1', title: '第1话 猫来了', number: 1, updatedAt: '2026-07-21' },
      { id: 'ch-10-2', title: '第2话 咖啡小偷', number: 2, updatedAt: '2026-07-14' },
      { id: 'ch-10-3', title: '第3话 键盘之谜', number: 3, updatedAt: '2026-07-07' },
    ],
    tags: ['搞笑', '日常', '萌宠', '职场'],
    updatedAt: '2026-07-21',
    createdAt: '2026-06-05',
    isHot: false,
    isNew: true,
  },
  {
    id: 'comic-11',
    title: '恶魔的契约',
    author: '文彩元',
    category: '悬疑',
    categorySlug: 'mystery',
    status: '连载中',
    description: '大学生金在宇一天晚上做了一个奇怪的梦，梦中他与一个自称恶魔的存在签订了契约。第二天醒来，他发现自己拥有了看穿他人谎言的能力。然而这个能力也给他带来了无法预料的麻烦和危险。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20supernatural%20mystery%20manga%20illustration%2C%20young%20man%20with%20mysterious%20glowing%20eyes%2C%20dark%20supernatural%20aura%2C%20shadowy%20figure%20in%20background%2C%20tense%20atmosphere%2C%20dark%20and%20red%20color%20palette%2C%20detailed%20gothic%20aesthetic&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    rating: 8.9,
    views: 610000,
    chapters: [
      { id: 'ch-11-1', title: '第1话 梦中之约', number: 1, updatedAt: '2026-07-20' },
      { id: 'ch-11-2', title: '第2话 觉醒', number: 2, updatedAt: '2026-07-13' },
      { id: 'ch-11-3', title: '第3话 代价', number: 3, updatedAt: '2026-07-06' },
    ],
    tags: ['悬疑', '超自然', '心理', '惊悚'],
    updatedAt: '2026-07-20',
    createdAt: '2026-06-12',
    isHot: false,
    isNew: true,
  },
  {
    id: 'comic-12',
    title: '北村咖啡店',
    author: '金多美',
    category: '都市',
    categorySlug: 'urban',
    status: '已完结',
    description: '在首尔北村的一家传统韩屋咖啡店里，老板和顾客们的故事交织在一起。每一杯咖啡背后都藏着一段人生，每一个角落都发生过动人的故事。这是一部关于人与人之间温暖连接的都市治愈漫画。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20slice%20of%20life%20coffee%20shop%20manga%20illustration%2C%20traditional%20hanok%20coffee%20shop%20interior%2C%20barista%20making%20coffee%2C%20warm%20cozy%20atmosphere%2C%20afternoon%20sunlight%20through%20windows%2C%20healing%20vibe%2C%20soft%20earth%20tones%2C%20clean%20detailed%20art&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    rating: 9.1,
    views: 860000,
    chapters: [
      { id: 'ch-12-1', title: '第1话 开店', number: 1, updatedAt: '2026-06-30' },
      { id: 'ch-12-2', title: '第2话 第一位客人', number: 2, updatedAt: '2026-06-23' },
      { id: 'ch-12-3', title: '第3话 拿铁艺术', number: 3, updatedAt: '2026-06-16' },
    ],
    tags: ['都市', '治愈', '日常', '美食'],
    updatedAt: '2026-06-30',
    createdAt: '2026-03-01',
    isHot: false,
    isNew: false,
  },
];